import { Link, useLocation } from "react-router-dom";
import somLogo from '../assets/logo-som.jpg';
import userIcon from '../assets/Icono_Avatar.svg';
import './Layout.css';
import { FiLogOut } from "react-icons/fi";
import { useAuth } from "../hooks/useAuth";

const NAV_LINKS = [
    { to: "/rulesView",    label: "Motor de Reglas" },
    { to: "/home",         label: "Consumos" },
    { to: "/transactions", label: "Transacciones" },
];

function Layout({ children }) {
    const { logout, user } = useAuth();
    const location = useLocation();

    return (
        <div className="layout-root">
            <header className="app-header">
                <div className="header-left">
                    <Link to="/rulesView" className="card-link">
                        <img src={somLogo} className="company-logo" alt="OSPM" />
                    </Link>

                    <nav className="header-nav">
                        {NAV_LINKS.map(({ to, label }) => (
                            <Link
                                key={to}
                                to={to}
                                className={`nav-link${location.pathname === to ? " nav-link-active" : ""}`}
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>
                </div>

                <div className="header-right">
                    <img src={userIcon} className="user-icon" alt="Usuario" />
                    <span className="username">{user}</span>
                    <button
                        onClick={logout}
                        className="logout-btn"
                        title="Cerrar sesión"
                        aria-label="Cerrar sesión"
                    >
                        <FiLogOut size={18} />
                    </button>
                </div>
            </header>

            <main className="layout-content">
                {children}
            </main>

            <footer className="layout-footer">
                Version 1.1.1 – Powered by{" "}
                <span className="footer-brand">OSPM</span>
            </footer>
        </div>
    );
}

export default Layout;
